import React from 'react';
import { useParams } from 'react-router-dom';

const DepartmentDetail = () => {
  const { id } = useParams();
  
  return (
    <div className="department-detail-page">
      <div className="page-header">
        <div className="container">
          <h1>Department Details</h1>
        </div>
      </div>
      <div className="container section">
        <p>Department details for ID: {id} - To be implemented</p>
      </div>
    </div>
  );
};

export default DepartmentDetail;
